module.exports = __webpack_public_path__ + "static/media/closeIcon4.b272860e.svg";